import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import { themeColors } from "@/theme/colors";

Vue.use(Vuetify);

const opts = {
  // Disable Vuetify default assets (Roboto, etc.) to avoid font conflicts
  defaultAssets: false,
  theme: {
    themes: {
      light: {
        primary: themeColors.primary,
        secondary: themeColors.secondary,
        accent: themeColors.accent,
        info: themeColors.info,
        success: themeColors.success,
        warning: themeColors.warning,
        error: themeColors.error,
        red: themeColors.error,
        green: "#4caf50",
      },
      dark: {
        primary: themeColors.primary,
        success: themeColors.success,
        red: themeColors.error,
      },
    },
  },
  icons: {
    iconfont: "mdiSvg",
  },
  // Add accessibility options
  options: {
    customProperties: true,
  },
  // Improve focus management
  defaults: {
    VOverlay: {
      hideOverlay: false,
      persistent: false,
    },
    VDialog: {
      persistent: false,
      retainFocus: true,
    },
  },
  // Set default font family
  defaultFont: {
    fontFamily: '"Noto Sans Lao Looped", "Poppins", sans-serif',
  },
};

export default new Vuetify(opts);
